export default "__VITE_ASSET__BZK4WzJ6__"